var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "gift-card-config-pane",
    },
    [
      _c(
        "el-form",
        {
          ref: "formData",
          staticStyle: { width: "70%" },
          attrs: { "label-width": "100px", model: _vm.formData },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标题：", prop: "title" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入标题" },
                model: {
                  value: _vm.formData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "title", $$v)
                  },
                  expression: "formData.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "副标题：", prop: "subtitle" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入副标题" },
                model: {
                  value: _vm.formData.subtitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "subtitle", $$v)
                  },
                  expression: "formData.subtitle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "类型：", prop: "type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formData.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "type", $$v)
                    },
                    expression: "formData.type",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "member" } }, [
                    _vm._v("\n          会员礼品卡\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "vip" } }, [
                    _vm._v("\n          大客户礼品卡\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "面值：", prop: "faceValue" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: { click: _vm.handleAddFaceValue },
                },
                [_vm._v("\n        新增\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.formData.faceValues,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "面值", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: {
                                min: 0,
                                precision: 0,
                                size: "small",
                                placeholder: "请输入面值",
                              },
                              model: {
                                value: scope.row.faceValue,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "faceValue", $$v)
                                },
                                expression: "scope.row.faceValue",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "赠送提示", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入提示",
                                size: "small",
                              },
                              model: {
                                value: scope.row.tip,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "tip", $$v)
                                },
                                expression: "scope.row.tip",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "额外赠送提示", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入额外赠送提示",
                                size: "small",
                              },
                              model: {
                                value: scope.row.extraTip,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "extraTip", $$v)
                                },
                                expression: "scope.row.extraTip",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "优惠券" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectCoupon(
                                          scope.row,
                                          "gift"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                优惠券\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            scope.row.coupons && scope.row.coupons.length > 0
                              ? _c(
                                  "div",
                                  _vm._l(scope.row.coupons, function (coupon) {
                                    return _c(
                                      "div",
                                      { key: coupon.couponFnId },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(coupon.couponName) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteCheckedCoupon(
                                                  scope.row,
                                                  coupon,
                                                  "gift"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  移除\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "额外优惠券" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectCoupon(
                                          scope.row,
                                          "extra_gift"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                额外优惠券\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            scope.row.extraCoupons &&
                            scope.row.extraCoupons.length > 0
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.extraCoupons,
                                    function (coupon) {
                                      return _c(
                                        "div",
                                        { key: coupon.couponFnId },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "success",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(coupon.couponName) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteCheckedCoupon(
                                                    scope.row,
                                                    coupon,
                                                    "extra_gift"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  移除\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-button", {
                              attrs: { type: "text", icon: "el-icon-delete" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteFaceValue(scope.$index)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态：", prop: "activateStatus" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formData.activateStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "activateStatus", $$v)
                    },
                    expression: "formData.activateStatus",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "active" } }, [
                    _vm._v("\n          上架\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "inactive" } }, [
                    _vm._v("\n          下架\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "描述：", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  autosize: { minRows: 4, maxRows: 6 },
                  placeholder: "请输入描述",
                  maxlength: 1000,
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.formData.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "description", $$v)
                  },
                  expression: "formData.description",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "封面图片：" } }, [
            _c(
              "div",
              { staticClass: "cover-image" },
              _vm._l(4, function (idx) {
                return _c("gift-card-upload-pane", {
                  key: "cover-image-item-" + idx + "-refresh-" + _vm.refreshKey,
                  attrs: {
                    "cover-image-url": _vm.getImgUrl(idx),
                    "img-access-domain": _vm.imgAccessDomain,
                  },
                  on: {
                    uploadSuccess: function ($event) {
                      return _vm.handleUploadSuccess(idx, $event)
                    },
                  },
                })
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("formData")
                    },
                  },
                },
                [_vm._v("\n        保存\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.selectCouponDialog.dialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.selectCouponDialog, "dialogVisible", $event)
            },
          },
        },
        [
          _c(
            "el-select",
            {
              attrs: {
                filterable: "",
                clearable: "",
                remote: "",
                "remote-method": _vm.fetchCoupons,
                loading: _vm.selectCouponDialog.couponLoading,
                size: "small",
                "value-key": "couponFnId",
                placeholder: "请选择额外优惠券",
              },
              model: {
                value: _vm.selectCouponDialog.checkedCoupon,
                callback: function ($$v) {
                  _vm.$set(_vm.selectCouponDialog, "checkedCoupon", $$v)
                },
                expression: "selectCouponDialog.checkedCoupon",
              },
            },
            _vm._l(_vm.selectCouponDialog.couponList, function (item) {
              return _c("el-option", {
                key: item.couponFnId,
                attrs: { label: item.couponName, value: item },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.selectCouponDialog.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sureSelectCoupon },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }